import { type FC } from 'react';
import { ToastContainer } from 'react-toastify';

import { toastContainerProps } from '@/common/config/toast';

const ToastWrapper: FC = () => {
  return (
    <ToastContainer
      {...toastContainerProps}
      style={{ top: 'calc(var(--header-height, 72px) - 16px)' }}
    />
  );
};

export { ToastWrapper };
